import { fontFamilyMap } from '@/util/tag/pdf-draw'
import JsPDF from 'jspdf'

/**
 * 将 SVG 列表转换为 PDF 的二进制数据
 * @param {Array} svgList - SVG 列表
 * @param {Object} options - PDF 配置
 * @returns {Promise<ArrayBuffer>} - 返回 PDF 的二进制数据
 */
export async function getSvgListToPdfJSBinary(svgList, options = {}) {
  const doc = new JsPDF({
    orientation:
      options.format[0] > options.format[1] ? 'landscape' : 'portrait',
    compress: true,
    ...options,
  })
  // 处理批量补标签 有空白标签的情况
  let mySvgList = svgList.filter((item) => item)
  // 1. 遍历 SVG 元素数组
  for (let i = 0; i < mySvgList.length; i++) {
    if (i !== 0) doc.addPage()
    const svg = mySvgList[i]
    // 2. 将 SVG 字符串解析为 DOM 元素
    const parser = new DOMParser()
    const svgElement = parser.parseFromString(
      svg,
      'image/svg+xml'
    ).documentElement
    /**
     * 这里说一下为什么需要这么做，因为在 svg2pdf 的源码中他在获取元素上的字体，然后会采用这个字体，如果不存在它
     * 第一：会报解析错误
     * 第二：如果解析到没有 font-family 属性它会采用默认的 times字体，会导致中文乱码
     * 第三：如果字重不是数字形式的内部也会解析出现问题
     * 第四：可能是我没有看完源码中的解析流程，如果后续有大佬了解此包运行逻辑请务必修改此处糟糕的逻辑（😁）
     */
    svgElement.style.fontFamily = 'msyh' // 这里这样设置没问题(笑死它根本不用)
    svgElement.querySelectorAll('tspan').forEach((el) => {
      const parent = el.parentElement
      const fontFamily = parent?.getAttribute('font-family') || '微软雅黑'
      const font = fontFamilyMap[fontFamily]
      el.setAttribute('font-family', font ?? 'msyh')
      const inheritedFontWeight = parent?.getAttribute('font-weight') || '400'
      // 黑体暂不支持加粗
      el.setAttribute(
        'font-weight',
        inheritedFontWeight === 'bold' && font !== 'simhei' ? '700' : '400'
      )
    })
    // 找到背景色，就是 svg 元素下的第一个 rect 元素
    const bg = svgElement.querySelector('rect')
    if (
      bg &&
      bg.getAttribute('width') === '100%' &&
      bg.getAttribute('height') === '100%'
    ) {
      // 背景色为纯白色直接删除
      if (['#fff', '#ffffff'].includes(bg.getAttribute('fill'))) {
        svgElement.removeChild(bg)
      }
      // 背景色为纯黑色，设置宽高为 svg 的宽高，100% 会被 svg2pdf 库认为是 100px 导致背景色太小
      if (['#000', '#000000'].includes(bg.getAttribute('fill'))) {
        bg.setAttribute('width', svgElement.getAttribute('width'))
        bg.setAttribute('height', svgElement.getAttribute('height'))
      }
    }
    // 疑惑吧为什么 rect 也需要，那就对了我也疑惑
    svgElement.querySelectorAll('text,rect').forEach((el) => {
      const fontFamily = el?.getAttribute('font-family') || '微软雅黑'
      el.setAttribute('font-family', fontFamilyMap[fontFamily])
    })
    await doc.svg(svgElement, {
      removeInvalid: true,
      width: options.format[0] ?? 0,
      height: options.format[1] ?? 0,
    })
  }
  return doc.output('arraybuffer')
}
